import { PLAN_GROUPS_WITH_SIMPLE_SIGNUP_ENABLED } from 'settings/_planGroupCode'

export const isSimpleSignUpEnabled = (planGroupCode: string): boolean => {
  return PLAN_GROUPS_WITH_SIMPLE_SIGNUP_ENABLED.includes(planGroupCode)
}
